module.exports = __webpack_public_path__ + "img/Logo_LoginML.5a03d310.png";